var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{class:_vm.cardClass,style:(_vm.isActive ? 'background-color: ' + _vm.primary : ''),on:{"click":_vm.onClick}},[_c('p',[_vm._v(_vm._s(_vm.item.name))]),_c('span',[_vm._v(_vm._s(_vm.item.address))])])])}
var staticRenderFns = []

export { render, staticRenderFns }